import * as tslib_1 from "tslib";
/* tslint:disable:no-input-prefix */
import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, OnChanges, OnDestroy, SimpleChange, SimpleChanges, ViewContainerRef } from '@angular/core';
import * as Kendo from '@progress/kendo-angular-dialog';
import { BooleanConverter, InputConverter } from '../../../inputConverter';
import { LogLevel } from '../../../types';
import { BaseComponent } from '../../base.component';
var instantiateTimeout = 5;
var WindowComponent = /** @class */ (function (_super) {
    tslib_1.__extends(WindowComponent, _super);
    function WindowComponent(_vcr, LoggingService, cdr, elementRef) {
        var _this = _super.call(this, _vcr) || this;
        _this.LoggingService = LoggingService;
        _this.cdr = cdr;
        _this.openChange = new EventEmitter();
        _this.stateChange = new EventEmitter();
        _this._isOpened = false;
        _this._disableKeyboard = false;
        _this.modal = false;
        _this.isResizable = false;
        _this.isDraggable = false;
        _this.isMaximizable = false;
        _this.closable = true;
        _this.minWidth = null;
        _this.maxWidth = null;
        _this.width = null;
        _this.minHeight = null;
        _this.maxHeight = null;
        _this.height = null;
        _this.top = null;
        _this.left = null;
        _this.right = null;
        _this.close = function () {
            _this.isOpened = false;
        };
        _this.open = function () { _this.isOpened = true; };
        _this.toggle = function (open) { _this.isOpened = open !== undefined ? open : !_this.isOpened; };
        _this.registerEvent('openChange', _this.openChange);
        if (elementRef.nativeElement.title && !_this.windowTitle) {
            _this.windowTitle = elementRef.nativeElement.title;
            elementRef.nativeElement.removeAttribute('title');
        }
        return _this;
    }
    Object.defineProperty(WindowComponent.prototype, "includeGoogleAnalytics", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowComponent.prototype, "windowRef", {
        get: function () { return this.modal ? this.kendoDialogRef : this.kendowWindowRef; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowComponent.prototype, "isOpened", {
        get: function () { return this._isOpened; },
        set: function (open) {
            this._isOpened = BooleanConverter(open);
            if (open) {
                this.setupHeightConstraint();
                this.openChange.emit(open);
                this.LoggingService.Log("'" + (this.windowTitle || 'Untitled') + "' Window Opened", this.windowRef, LogLevel.Trace);
            }
            else {
                this.teardownHeightConstraint();
                this.openChange.emit(open);
                this.LoggingService.Log("'" + (this.windowTitle || 'Untitled') + "' Window Closed", this.windowRef, LogLevel.Trace);
            }
            this.cdr.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowComponent.prototype, "disableKeyboard", {
        get: function () { return this._disableKeyboard; },
        set: function (value) {
            this._disableKeyboard = BooleanConverter(value);
            this.setKeyboardShortcuts();
        },
        enumerable: true,
        configurable: true
    });
    WindowComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.isReady();
        this.openChange.subscribe(function (open) {
            if (open) {
                var instantiateInterval_1 = setInterval(function () {
                    if (_this.windowRef) {
                        clearInterval(instantiateInterval_1);
                        _this.setMaxes();
                        _this.setKeyboardShortcuts();
                        _this.setSize();
                    }
                }, instantiateTimeout);
            }
        });
    };
    WindowComponent.prototype.ngOnDestroy = function () {
        this.teardownHeightConstraint();
    };
    WindowComponent.prototype.ngOnChanges = function (changes) {
        if (changes.maxWidth || changes.maxHeight || changes.minWidth || changes.minHeight) {
            this.setMaxes();
        }
        if (changes.width || changes.height) {
            this.setSize();
        }
    };
    WindowComponent.prototype.setMaxes = function () {
        if (this.windowRef) {
            var windowDiv = this.getWindowDiv();
            if (windowDiv && !this.modal) {
                this.setDialogMaxes(windowDiv);
            }
            else if (windowDiv && this.modal) {
                this.setModalMaxes(windowDiv);
            }
        }
    };
    WindowComponent.prototype.getWindowDiv = function () {
        return this.windowRef ?
            this.modal ?
                this.windowRef._elRef.nativeElement.querySelector('.k-widget.k-window')
                : this.windowRef.el.nativeElement
            : null;
    };
    WindowComponent.prototype.setDialogMaxes = function (windowDiv) {
        var maxHeight = window.innerHeight;
        var maxWidth = window.innerWidth;
        windowDiv.style.maxHeight = this.maxHeight && this.maxHeight < maxHeight ? this.maxHeight + "px" : maxHeight + "px";
        windowDiv.style.maxWidth = this.maxWidth && this.maxWidth < maxWidth ? this.maxWidth + "px" : maxWidth + "px";
        windowDiv.style.minHeight = this.minHeight ? this.minHeight + "px" : null;
        windowDiv.style.minWidth = this.minWidth ? this.minWidth + "px" : null;
        windowDiv.style.left = this.right ? null : windowDiv.style.left;
        windowDiv.style.right = this.right ? this.right + "px" : null;
    };
    WindowComponent.prototype.setModalMaxes = function (windowDiv) {
        windowDiv.style.maxHeight = null;
        windowDiv.style.maxWidth = null;
        if (!this.height) {
            windowDiv.style.maxHeight = '99vh';
        }
        if (!this.width) {
            windowDiv.style.maxWidth = '99vw';
        }
    };
    WindowComponent.prototype.setSize = function () {
        var windowDiv = this.getWindowDiv();
        if (windowDiv && this.modal) {
            if (this.height) {
                windowDiv.style.height = typeof this.height === 'number' || /^\d+$/.test(this.height) ? this.height + "px" : this.height;
            }
            if (this.width) {
                windowDiv.style.width = typeof this.width === 'number' || /^\d+$/.test(this.width) ? this.width + "px" : this.width;
            }
        }
    };
    WindowComponent.prototype.setKeyboardShortcuts = function () {
        if (this.windowRef) {
            if (this.disableKeyboard) {
                this.windowRef.tabIndex = null;
            }
            else {
                this.windowRef.tabIndex = 0;
            }
            this.cdr.detectChanges();
        }
    };
    WindowComponent.prototype.setupHeightConstraint = function () {
        var _this = this;
        window.addEventListener('resize', function () { _this.setMaxes(); });
    };
    WindowComponent.prototype.teardownHeightConstraint = function () {
        var _this = this;
        window.removeEventListener('resize', function () { _this.setMaxes(); });
    };
    WindowComponent.prototype.preventEvent = function (e, prevent) {
        if (prevent) {
            e.stopImmediatePropagation();
        }
    };
    WindowComponent.prototype.stateChangeEvent = function (event) {
        this.stateChange.emit(event);
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], WindowComponent.prototype, "modal", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], WindowComponent.prototype, "isResizable", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], WindowComponent.prototype, "isDraggable", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], WindowComponent.prototype, "isMaximizable", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], WindowComponent.prototype, "closable", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], WindowComponent.prototype, "minWidth", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], WindowComponent.prototype, "maxWidth", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], WindowComponent.prototype, "minHeight", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], WindowComponent.prototype, "maxHeight", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], WindowComponent.prototype, "top", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], WindowComponent.prototype, "left", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], WindowComponent.prototype, "right", void 0);
    return WindowComponent;
}(BaseComponent));
export { WindowComponent };
